import { StyleSheet } from 'react-native';
import styled from 'styled-components/native';
import { COLORS } from '../WasteTheme';
import withHover from './core/withHover';
import {Util} from './core/Util';

const PageBlock = styled.View`
    flex-grow: 2;
    background-color: #ffffff;
    box-shadow: 0px 0px 10px #c8c8c8;
    padding: 10px;
    margin: 10px;
    height: ${props => props.height ? props.height : "auto"}};
    border-radius: ${props => props.theme.rounded != undefined ? (props.theme.rounded * 4) + "px" : 0};
    elevation: 20;
`

const BasicText = styled.Text`
    color: ${props => props.colour || props.theme.foreground || 'green'};
    font-family: Red Hat Display;
    font-size: ${props => props.theme.sm || '12px'};
    font-weight: ${props => props.weight || "500"};
    letter-spacing: 0.50px;
    text-align: ${props => props.align || "left"};
`;

const Disclaimer = styled(BasicText)`
    color: ${props => props.colour || props.theme.grey || 'grey'};
    font-size: ${props => props.theme.xsm || '10px'};

`;

const Paragraph = styled(BasicText)`
    background-color: ${props => props.warning ? '#cc0000' : '#ffffff'};
`;

const Heading = styled(BasicText)`
   font-size: ${props => props.theme.lg};
`;

//width: fit-content;
//margin: 10px;
const Button = styled.TouchableOpacity`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: white;
    padding: ${props => props.theme.input.padding? props.theme.input.padding : "10px" };
    background-color: ${props => props.theme.brandColor? props.theme.brandColor : "initial" };
    border-radius: ${props => props.theme.rounded != undefined ? (props.theme.rounded * 2) + "px" : "5px"};
    font-family: ${props => props.theme.fontFamily || "Red Hat Display" };
`;

const SmallButton = styled(Button)`
    justify-content: space-around;
    width: 120px;
`;

const Heading2 = styled(BasicText)`
   font-size: ${props => props.theme.med};
`;

const Heading3 = styled(BasicText)`
   font-size: ${props => props.theme.med};
   margin-bottom: 10px;
`;

const Heading4 = styled(BasicText)`
   font-size: ${props => props.theme.sm};
   font-weight: ${props => props.weight? props.weight : "normal"}
`;

const StatBlock = styled.View`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding-bottom: 20px;
    flex-basis: auto;
`;

const FlexBlock = styled.View`
    flex-direction: ${props => props.flexDirection ? props.flexDirection : "row"};
    justify-content: ${props => props.justify ? props.justify : "center"};
`;

const FlexBlockWrapped = styled(FlexBlock)`
    justify-content: space-around;
    flex-basis: ${props => props.minWidth != undefined? props.minWidth : "100%"};
    flex-direction: row;
`;

const FlexElement = styled.View`
    flex: ${props => props.flex != undefined ? props.flex : "1"};
`;

const Loading = styled.Text`
    font-style: italic;
`;

const StrongText = styled.Text`
    font-size: ${props => props.theme.reg};

`;

const Label = styled(BasicText)`
    font-size: 16px;
`;

const SmallLabel = styled(BasicText)`
    font-weight: bold;
`;

const MetricStackTitle = styled(BasicText)`
    color: white;
    font-weight: bold;
    font-size: 14px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
`;

const AppWrapper = styled.SafeAreaView`
    padding-top: 20px;
    flex-basis: 100%;
    flex-wrap: wrap;
    flex-direction: row;
`;

const AppShellStyle = styled.View`
    box-shadow: 1px 1px 10px rgba(0,0,0,0.1);
    border-radius: 10px;
    background-color: white;
    padding: 10px;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    flex-grow: 4;
`;

const PageWrapper = styled.View`
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
`;

const ShinyBlockOuter = styled.View`
    background-color: white;
    border-radius: 8px;
    width: ${props => props.flexBasis != undefined? props.flexBasis: "95%"};
    margin-vertical: 10px;
    margin-horizontal: 5px;
    flex-direction: column;
    elevation: 5;
    shadow-color: '#52006A;
    box-shadow: 0px 2px 5px rgba(0,0,0,0.2);
    flex-grow: ${props => Util.isMobile()? 0 : 1};
`;

const BorderlessShinyBlockOuter = styled(ShinyBlockOuter)`
    evelation: 0;
    shadow-color: none;
    box-shadow: none;
`;

const ShinyBody = styled.View`
    padding: 13px;
    flex-direction: ${props => props.flexDirection ? props.flexDirection : "column"};
    justify-content: space-between;
    align-items: ${props => props.flexDirection && props.flexDirection == "row"? "center" : "stretch"};
    flex-grow: 1;
`;

//const ShinyHeadingWithHover = withHover(ShinyHeading);
const ShinyHeading = withHover(styled.View`
    background-color: ${props => props.hovered && props.hover ? COLORS.acid_green : COLORS.navy};
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
    padding-top: 6px;
    padding-bottom: 4px;
    padding-left: 8px;
    padding-right: 8px;
    flex-direction: row;
    justify-content: space-between;
`);

const ExtraStyles = StyleSheet.create({
    buttonLight: {
        display: "flex", 
        flexDirection: "row", 
        justifyContent: "space-evenly", 
        alignItems: "center",
        width: "100%",
        padding: 10,
        color: "#949492",
        borderWidth: 1,
        borderColor: "#d8d8d8"
    },
    blueButton: {
        borderColor: COLORS.wsc_blue,
        borderWidth: 2,
        borderRadius: 3
    }
});

const ModalSubmitButton = ({children, onPress = undefined, theme = undefined}) => {
    const MyButton = styled(Button)`
        width: 150px;
        text-align: center;
        margin: 0 auto;
        margin-top: 10px;
    `;

    return <MyButton onPress={onPress} theme={theme}>
        <BasicText align="center" weight="bold" colour="white">{children}</BasicText>
    </MyButton>;
};

export {
    PageBlock,
    BasicText,
    Disclaimer,
    Paragraph,
    Heading,
    Heading2,
    Heading3,
    Heading4,
    Button,
    SmallButton,
    StatBlock,
    FlexBlock,
    FlexBlockWrapped,
    FlexElement,
    Loading,
    StrongText,
    Label,
    SmallLabel,
    MetricStackTitle,
    ShinyBlockOuter,
    ShinyBody,
    ShinyHeading,
    AppShellStyle,
    ExtraStyles,
    PageWrapper,
    AppWrapper,
    ModalSubmitButton,
    BorderlessShinyBlockOuter
};